import GuarantorsPropertiesText from './GuarantorsPropertiesText';

export default GuarantorsPropertiesText;
